const isBlank = (value: string | undefined): boolean => !value || value.trim() === "";

export const validatePositiveInteger =
  (label: string) =>
  (value: string): true | string => {
    if (isBlank(value)) return `${label} is required.`;
    const parsed = Number(value);
    return (Number.isInteger(parsed) && parsed >= 1) || `${label} must be a whole number of at least 1.`;
  };

export const validateNonNegativeNumber =
  (label: string, isRequired = false) =>
  (value: string): true | string => {
    if (isBlank(value)) return isRequired ? `${label} is required.` : true;
    const parsed = Number(value);
    return (Number.isFinite(parsed) && parsed >= 0) || `${label} must be 0 or more.`;
  };

/** Digits with an optional decimal part: no sign, exponent or letters. */
export const validateNonNegativeDecimal =
  (label: string) =>
  (value: string): true | string => {
    if (isBlank(value)) return `${label} is required.`;
    return /^\d+(\.\d+)?$/.test(value.trim()) || `${label} must be a number, 0 or more.`;
  };

// Keys a number input accepts that a non-negative decimal must not have (sign and exponent)
export const NON_DECIMAL_KEYS = ["e", "E", "+", "-"];

export const validateImageUrl = (value: string): true | string => {
  if (isBlank(value)) return "Gift image is required.";
  return /^https?:\/\/\S+$/i.test(value.trim()) || "Enter a valid image URL starting with http(s)://";
};

/** The backend stores discount_value as a whole number; a percentage cannot go above 100. */
export const validateDiscountValue =
  (isPercentage: boolean) =>
  (value: string): true | string => {
    if (isBlank(value)) return "Discount value is required.";
    const parsed = Number(value);
    if (!Number.isInteger(parsed) || parsed < 0) return "Discount value must be a whole number, 0 or more.";
    return !isPercentage || parsed <= 100 || "A percentage cannot be more than 100.";
  };
